import React from 'react'
import { Routes, Route } from 'react-router-dom'

// Route Components
import GuestOnlyRoute from './auth/guest_only_route'
import AuthenticatedRoute from './auth/authenticated_route'

// Route Configuration
import { routes } from './route-config'

const AppRouter: React.FC = () => {
  return (
    <Routes>
      {routes.map(({ path, element: Component, type }) => (
        <Route
          key={path}
          path={path}
          element={
            type === 'guest' ? (
              <GuestOnlyRoute>
                <Component />
              </GuestOnlyRoute>
            ) : type === 'authenticated' ? (
              <AuthenticatedRoute>
                <Component />
              </AuthenticatedRoute>
            ) : (
              <Component />
            )
          }
        />
      ))}
    </Routes>
  )
}

export default AppRouter
